var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachment = function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M1.273 14.148c1.318 1.318 3.455 1.318 4.795-.023l.41-.409.204-.205 6.41-6.409c.909-.91.954-2.318.045-3.227-.91-.91-2.318-.864-3.227.045l-6.455 6.455c-.25.25-.25.659 0 .909s.659.25.909 0l6.455-6.455c.409-.409 1-.454 1.409-.045s.364 1-.046 1.409l-6.409 6.41-.205.204-.409.409c-.818.818-2.159.84-2.977.023-.818-.819-.818-2.137.023-2.978l5.977-5.977.91-.91.272-.272c1.25-1.25 3.318-1.273 4.569-.023s1.25 3.296-.023 4.568L7.319 14.24c-.25.25-.25.659 0 .909s.659.25.909 0l6.59-6.591c1.774-1.773 1.796-4.614.024-6.387s-4.614-1.75-6.387.023l-.273.272-.909.91-5.955 5.954c-1.34 1.341-1.363 3.5-.045 4.819"
  }))));
};
export default SvgAttachment;